import { render } from "./CSelect.vue?vue&type=template&id=66ff4bfc&ts=true&lang=pug"
import script from "./CSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSelect.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__